import { useLayoutEffect, useRef, useState } from "react";
import { tableMenuItems, userLeadTable } from "../../adminData";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import GlobalTableDropDown from "../../GlobalTableDropDown";
import { formatDate, formatPhoneNumber } from "../../../../../utilities/utils";
import Loader from "../../../../commons/Loader";
import Pagination from "../../../pagination";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const UserLeadsTable = ({ leadData, getUpdateData }) => {
  const checkbox = useRef();
  const [checked, setChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [selectedPeople, setSelectedPeople] = useState([]);
  const [showMenu, setShowMenu] = useState(null);

  // useLayoutEffect(() => {
  //   const isIndeterminate =
  //     selectedPeople?.length > 0 && selectedPeople?.length < data?.length;
  //   setChecked(selectedPeople.length === data?.length);
  //   setIndeterminate(isIndeterminate);
  //   checkbox.current.indeterminate = isIndeterminate;
  // }, [selectedPeople]);

  function toggleAll() {
    setSelectedPeople(checked ? [] : leadData);
    setChecked(!checked);
  }

  const handleMenuItems = (userId, flag) => {
    if (!flag) {
      setShowMenu(userId.id);
    } else {
      setShowMenu(null);
    }
  };

  const { data, meta } = leadData ?? {};
  const { current_page, last_page, per_page } = meta ?? {};

  return (
    <>
      <div className="px-4 sm:px-6 lg:px-8 hidden md:block">
        {!data ? (
          <Loader isLoading={true} />
        ) : (
          <div className="mt-8 flow-root">
            <div className="table-scroller -mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white border border-[#EBEFF3] rounded-md p-5">
              <div className="inline-block min-w-full py-2 align-middle">
                <div className="relative">
                  <table className="min-w-full table-fixed divide-y divide-gray-300">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="relative pr-7 sm:w-12 sm:pr-6"
                        >
                          <div
                            className={`form-group relative flex items-center transition-all duration-300 ease-in cursor-pointer`}
                          >
                            <input
                              id="1"
                              aria-describedby="comments-description"
                              name="test"
                              type="checkbox"
                              ref={checkbox}
                              checked={checked}
                              onChange={toggleAll}
                              className="rounded border border-solid border-[#CCD0D4] relative cursor-pointer inline-block w-5 h-5 leading-[0px]"
                            />
                          </div>
                        </th>
                        <th
                          scope="col"
                          className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-bold text-[#485868]"
                        >
                          # ID
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Name
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Email
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Phone Number
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Address
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Created at
                        </th>
                        <th
                          scope="col"
                          className="relative py-3.5 pl-3 pr-4 sm:pr-0"
                        >
                          <span className="sr-only"></span>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {data &&
                        data.map((lead, index) => (
                          <tr
                            key={lead.email}
                            className={
                              selectedPeople.includes(lead)
                                ? "bg-gray-50"
                                : undefined
                            }
                          >
                            <td className="relative pr-7 sm:w-12 sm:pr-6">
                              <div
                                className={`form-group relative flex items-center transition-all duration-300 ease-in cursor-pointer`}
                              >
                                <input
                                  id="1"
                                  aria-describedby="comments-description"
                                  name="test"
                                  type="checkbox"
                                  ref={checkbox}
                                  value={lead.email}
                                  checked={selectedPeople.includes(lead)}
                                  onChange={(e) =>
                                    setSelectedPeople(
                                      e.target.checked
                                        ? [...selectedPeople, lead]
                                        : selectedPeople.filter(
                                            (p) => p !== lead
                                          )
                                    )
                                  }
                                  className="rounded border border-solid border-[#CCD0D4] relative cursor-pointer inline-block w-5 h-5 leading-[0px]"
                                />
                              </div>
                            </td>
                            <td className="whitespace-nowrap lg:w-10 px-3 py-4 text-sm text-customGray">
                              {lead.id}
                            </td>
                            <td
                              className={classNames(
                                "whitespace-nowrap py-4 pr-3 text-sm font-normal",
                                selectedPeople.includes(lead)
                                  ? "text-primary"
                                  : "text-customGray"
                              )}
                            >
                              {lead.first_name?.concat(" ", lead.last_name)}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              {lead.email}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              {formatPhoneNumber(lead.phone_number)}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              {lead.city?.concat(", ", lead.county)}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              {formatDate(lead.created_at)}
                            </td>
                            <td>
                              <GlobalTableDropDown
                                data={lead}
                                showMenu={showMenu === lead.id}
                                callBack={handleMenuItems}
                                isLastIndex={index == data.length - 2}
                                menuItems={tableMenuItems}
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {!data ? (
        <Loader isLoading={true} />
      ) : (
        <div className="block md:hidden">
          <div>
            <ul>
              {data &&
                data.map((lead, index) => (
                  <li className="border border-solid border-[#EBEFF3] rounded-md p-5 mb-[14px] flex justify-between bg-[#ffffff]">
                    <ul>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          # ID
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {lead.id}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Name
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {lead.first_name?.concat(" ", lead.last_name)}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Email
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {lead?.email}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Phone Number
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {formatPhoneNumber(lead.phone_number)}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Address
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {lead.city?.concat(", ", lead.county)}
                        </span>
                      </li>
                      <li className="flex items-center mb-[14px] gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          Created At
                        </h6>
                        <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                          {formatDate(lead.created_at)}
                        </span>
                      </li>
                    </ul>
                    <div>
                      <GlobalTableDropDown
                        data={lead}
                        showMenu={showMenu === lead.id}
                        callBack={handleMenuItems}
                        isLastIndex={index == data.length - 2}
                        menuItems={tableMenuItems}
                      />
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      )}
      {data?.length > 0 && (
        <Pagination
          currentPage={current_page}
          totalPages={last_page}
          nextPage={getUpdateData}
          previousPage={getUpdateData}
          directIntoPage={getUpdateData}
          perPageItem={per_page}
          showNumberOfPages={3}
        />
      )}
    </>
  );
};

export default UserLeadsTable;
